import React from "react";
import { ExternalLink } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-black mt-24"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div>
          <div className="font-display text-2xl tracking-wider uppercase">
            ESTEL · Torneio de Jogos Eletrónicos
            <span className="text-[#00F0FF]"> 25/26</span>
          </div>
          <p className="text-xs uppercase tracking-[0.25em] text-white/40 mt-2">
            Escola Profissional · Departamento de Multimédia
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
          <a
            href="https://estel.edu.pt/"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-estel-link"
            className="inline-flex items-center gap-2 border border-[#00F0FF] bg-[#00F0FF] text-black px-5 py-3 text-xs font-bold uppercase tracking-[0.2em] hover:bg-white hover:border-white transition-colors"
          >
            Site Oficial ESTEL
            <ExternalLink className="h-3.5 w-3.5" />
          </a>
          <div className="text-xs uppercase tracking-[0.25em] text-white/40">
            Feito com{" "}
            <span className="text-[#FF3B30]">▮</span> para a comunidade ESTEL
          </div>
        </div>
      </div>
    </footer>
  );
}
